import React from "react";
import QueueIcon from "@mui/icons-material/Queue";
import { Button, Tooltip } from "@mui/material";
import { useRecordContext, useRedirect } from "react-admin";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { CURRICULUMS, StudentServicePath } from "utils/constants";

const CloneCurriculumButton = ({ label = "Клонирай", isMobile }) => {
  const record = useRecordContext();
  const redirect = useRedirect();
  const notifyError = useNotifyError();

  const handleClick = () => {
    if (!record) return;
    const resource = `${StudentServicePath}${CURRICULUMS}`;
    dataProvider
      .getOne(resource, { id: record?.id })
      .then(({ data }) => {
        // Contents are not cloned; copying them would need a dedicated endpoint.
        const cleaned = {
          name: data.name,
          degreeId: data.degreeId,
          specialityId: data.specialityId,
          studyTypeId: data.studyTypeId,
          yearsOfStudy: data.yearsOfStudy,
          admissionAfterEducationLevelId: data.admissionAfterEducationLevelId,
          pdfDocumentId: data.pdfDocumentId,
          validFrom: null,
        };
        const source = encodeURIComponent(JSON.stringify(cleaned));
        redirect(`/${resource}/create?source=${source}`);
      })
      .catch(error => {
        notifyError(error);
      });
  };

  return (
    <Tooltip title={isMobile ? label : ""}>
      <Button
        startIcon={isMobile ? null : <QueueIcon />}
        onClick={handleClick}
      >
        {isMobile ? <QueueIcon /> : label}
      </Button>
    </Tooltip>
  );
};

export default CloneCurriculumButton;
